import React from 'react';
import { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Header from '../../components/Elements/header/header';
import UserData from './userData/userData'
import StepsOfBuy from '../summary/navigatorBarSummary/stepsOfBuy/stepsOfBuy';
import NavigatorBar from '../chooseUserBuy/navigation/navigationBarCamp/navigationBarCamp';
import { setUsersPayer } from '../../reducers/reposReducers';
import axios from 'axios';
import { API_URL } from '../../config';
import ApiService from '../../services/ApiService';
import ChooseCampUser from "./chooseCapmUser/chooseUserCamp"
import PriceVariant from "./priceVariant/priceVariant"
import PaymentMethod from "./paymentMethod/paymentMethod"
import Installment from "./installment/installment"
import CampUserCard from "./CampUserCard/CampUserCard"
import CampDetails from "./CampDetails/CampDetails"
const CampWrapper = (props) => {
const [allert, setallert] = useState(false);
const getSubaccountsURL = `${API_URL}GetSubaccounts`;
const config = { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
const camp = JSON.parse( localStorage.getItem("campHeadingFull"))
const [trackingId, setTrackigId] = useState("");
const history = useHistory();
const apiService = ApiService.getInstance();    
const [stepsOf, setSteps] = useState(0)
const [paymentP24, setPaymentP24] = useState();
const [header, setHeader] = useState("/  PROCES ZAKUPU OBOZU")
const [stepsIndex, setStepsIndex] = useState(1)
const [wrapNavigator, setWrapNavigator] = useState(false);
const stepsList = ["Rejestracja", "Obóz i formalności", "Podsumowanie"]
const departure =localStorage.getItem("departure")
const [conectedPerson, setConectedPerson]=useState([]);
const [choosenPayVarian,setChoosenPayVarian]=useState([]);
const [choosenPaymentOption, setChoosenPaymentOption] = useState();
const [choosenInstallmet, setChoosenInstallmet] = useState([]);
const [res, setRes] = useState([]); //userData
const [parcipient, setParcipient]= useState([]);
const [nip, setNip]= useState("")
const [userData, setUserData] = useState({
    name:"",
    lastName:"",
    eMail:"",
    phone:"",
    pesel:"",
    bDay:"",
    street:"",
    flat:"",
    building:"",
    
    city:"",
    postalCode:"",
    
    
    courseAgeRangesDVID:"",
    courseDanceStyleDVID:"",
    school:"",
    departure:"",
    diet:"",
    discription:" ",
  


   })
  
   let [paymentMethodList, setPaymentMethodList]=useState(
    {
    apple:false,
    google:false,
    blik:false,
    debetCard: false,
    przelewy24: true,
    payPo:false}
)
const[dataPay, setDataPay ]=useState([])

function nextSteps(){
    if(stepsOf < 8){
        setSteps(stepsOf + 1)
    }
    
}
function prevSteps(){
    if(stepsOf > 0){
        setSteps(stepsOf - 1)
    }
}
function choosePayVariant(e){

    setChoosenPayVarian(e);
    nextSteps();
}
function showModalLogout(){
    let modalLogout = document.getElementById("modalLogout")
    modalLogout.classList.remove("hidden")
  }
  function tegetRelationsUsersst() {
    setallert(true);
    axios
        .get(getSubaccountsURL, config)
        .then((response) => {
        
            setConectedPerson(response.data)
       
            
          
         
            setTimeout(() => {
                setallert(false);
            }, 800);
        })
        .catch(function (error) {
            console.log(error)
            // if (error.response.status == 401) {
            //     history.push('/Error_sesja_wygasla');
            //     setallert(false);
            // }
        });
        apiService.apiGet('UserGet', (response) => {  
          
            localStorage.setItem('usersID',response.data.usersID)
            
     localStorage.setItem('userName',response.data.firstName +" "+ response.data.lastName)
     let datauser = response.data
     let bd = ""
     if(datauser.dateOfBirdth != null){
     bd  = datauser.dateOfBirdth.split(" ")[0]?.split("/")[2] +"-"+ datauser.dateOfBirdth.split(" ")[0]?.split("/")[0] +"-"+ datauser.dateOfBirdth.split(" ")[0]?.split("/")[1] 
     }
     setRes(response.data);
     setUserData({
        ...userData,
        ...{name:datauser.firstName,
            lastName:datauser.lastName,
            eMail:datauser.email,
            phone:datauser.phone,
            pesel:datauser.pesel,
            departure:departure,
            bDay:bd,
            street:datauser.street,
            building:datauser.building,
            flat:datauser.flat,
            city:datauser.city,
            postalCode:datauser.postalCode
        }
     })
     
      });
}
function moveFromChooseUSerToUSerData(){
   if(parcipient?.usersID != undefined){
    setUserData({
        ...userData,
        ...{name:parcipient.firstName,
            lastName:parcipient.lastName,
            eMail:parcipient.email,
            phone:parcipient.phone,
            pesel:parcipient.pesel,
            bDay:parcipient,
            street:parcipient.street,
            building:parcipient.building,
            flat:parcipient.flat,
            city:parcipient.city,
            postalCode:parcipient.postalCode
        }
     })
   }
   nextSteps();
}
  useEffect(()=>{
    tegetRelationsUsersst()
  },[])

    return <> 
    <Header >{header}</Header>
<div className="content">
<div className='contentSummary_wrapper'>

        <div className='contentSummary_header'>
        {header == '/  PROCES ZAKUPU OBOZU'?stepsOf != 0?<div className='contentSummary_back' onClick={prevSteps}>
            <svg className="helloIconSVG" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path fill="rgba(204,0,51,1)" d="M11.62 3.81 7.43 8l4.19 4.19-1.53 1.52L4.38 8l5.71-5.71 1.53 1.52z"/></svg>
            <p className='helloEmail'>POWRÓT</p>
            </div>:<div className='space_contentSummary_back'></div>:"" }
            <div className='nav_container'> 
            <StepsOfBuy  steps={stepsOf} choosen={stepsOf} stepsList={stepsList}></StepsOfBuy>
            {stepsIndex < 8?<NavigatorBar clickForSmalButton={prevSteps} wrapNavigator={wrapNavigator} steps={stepsOf}></NavigatorBar>:""}
            </div>
          
             {header == '/  PROCES ZAKUPU OBOZU'?<div className='contentSummary_logout test' onClick={showModalLogout}>
              <svg className="helloIconSVG" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 22C4.44772 22 4 21.5523 4 21V3C4 2.44772 4.44772 2 5 2H19C19.5523 2 20 2.44772 20 3V6H18V4H6V20H18V18H20V21C20 21.5523 19.5523 22 19 22H5ZM18 16V13H11V11H18V8L23 12L18 16Z" fill="rgba(204,0,51,1)"></path></svg>
              <p className='helloEmail'>WYLOGUJ SIĘ</p>
            </div>:""
}  

        </div>
        {stepsOf == 0?<ChooseCampUser userId={res.usersID} tegetRelationsUsersst={tegetRelationsUsersst} setWrapNavigator={setWrapNavigator} wrapNavigator={wrapNavigator} setTrackigId={setTrackigId} setHeader={setHeader} parcipient={parcipient?.usersID} next={moveFromChooseUSerToUSerData} setParcipient={setParcipient} option={res} conectedPerson={conectedPerson} setConectedPerson={setConectedPerson} userData={userData} setUserData={setUserData}></ChooseCampUser>:""}   
         {stepsOf == 1?<UserData setWrapNavigator={setWrapNavigator}  wrapNavigator={wrapNavigator} setHeader={setHeader} parcipient={parcipient?.usersID} next={nextSteps} userData={userData} setUserData={setUserData} option={res}></UserData>:""}
         {stepsOf == 2?<PriceVariant setWrapNavigator={setWrapNavigator}  wrapNavigator={wrapNavigator} setDataPay={setDataPay} dataPay={dataPay} setHeader={setHeader} parcipient={parcipient?.usersID} next={(e)=>{choosePayVariant(e)}} userData={userData} setUserData={setUserData} option={res}></PriceVariant>:""}
         {stepsOf == 3?<PaymentMethod setWrapNavigator={setWrapNavigator}  wrapNavigator={wrapNavigator} setNavigator={setSteps} setNip={setNip} paymentP24={paymentP24} setPayP24={setPaymentP24} setHeader={setHeader}  paymentMethodList={paymentMethodList} setPaymentMethodList={setPaymentMethodList} onChoose={(e)=>{setChoosenPaymentOption(e)}}  choosenPayVarian={choosenPayVarian} parcipient={parcipient?.usersID} next={nextSteps} userData={userData} setUserData={setUserData} option={res}></PaymentMethod>:""}
         {stepsOf == 4?<Installment setWrapNavigator={setWrapNavigator}  wrapNavigator={wrapNavigator} paymentMethodList={paymentMethodList} setNavigator={setSteps} nip={nip} choosenInstallmet={choosenInstallmet} setChoosenInstallmet={setChoosenInstallmet} listOfInstallment={choosenPayVarian} setPayP24={setPaymentP24} setHeader={setHeader}  paymentMethodList={paymentMethodList} setPaymentMethodList={setPaymentMethodList} onChoose={(e)=>{setChoosenPaymentOption(e)}}  choosenPayVarian={choosenPayVarian} parcipient={parcipient?.usersID} next={nextSteps} userData={userData} setUserData={setUserData} option={res}></Installment>:""}
         {stepsOf == 5?<CampUserCard
          wrapNavigator={wrapNavigator}
         setWrapNavigator={setWrapNavigator}
         paymentMethodList={paymentMethodList} setNavigator={setSteps} nip={nip}
         dataToSend={
            {choosenInstallmet:choosenInstallmet,
            userData:userData,
            parcipient:parcipient,
            res:res,
            nip:nip,
            trackingId:trackingId,
            choosenPaymentOption:choosenPaymentOption,
            paymentP24:paymentP24,
            choosenPayVarian:choosenPayVarian}
         } setHeader={setHeader} parcipient={parcipient?.usersID} next={nextSteps} userData={userData} setUserData={setUserData} option={res} setWrapNavigator={setWrapNavigator}></CampUserCard>:""}
         {stepsOf == 6?<CampDetails paymentMethodList={paymentMethodList}   wrapNavigator={wrapNavigator} paymentP24={paymentP24} trackingId={trackingId} setWrapNavigator={setWrapNavigator} choosenInstallmet={choosenInstallmet} setChoosenInstallmet={setChoosenInstallmet} listOfInstallment={choosenPayVarian} setPayP24={setPaymentP24} setHeader={setHeader}  paymentMethodList={paymentMethodList} setPaymentMethodList={setPaymentMethodList} onChoose={(e)=>{setChoosenPaymentOption(e)}}  choosenPayVarian={choosenPayVarian} parcipient={parcipient?.usersID} next={nextSteps} userData={userData} setUserData={setUserData} option={res}></CampDetails>:""}

</div></div>

    
    </>;
    }

export default CampWrapper;
